import { OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Data } from '../../helpers';
// import the WindowRef provider
import { WindowRef } from '../../windowHref';
import { LoginService } from '../';
import { EmbedVideoService } from 'ngx-embed-video';
import { DateTimeConverstionService } from '../../services/index';
var ViewCourseComponent = /** @class */ (function () {
    function ViewCourseComponent(embedService, winRef, location, data, userService, router, route, timeZoneConverstionService) {
        this.embedService = embedService;
        this.winRef = winRef;
        this.data = data;
        this.userService = userService;
        this.router = router;
        this.route = route;
        this.timeZoneConverstionService = timeZoneConverstionService;
        this.query = '';
        this.courseDetail = {};
        this.creator = {};
        this.startTime = {};
        this.endTime = {};
        this.url = '';
        this.courseinfo = {};
        this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
        this.schedual = { selectedDaysOfWeekStr: [] };
        this.video_html = "";
        this.daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        this.showLogOffModalDialog = false;
        this.showLogOffMessageTitle = "";
        this.showLogOffMessages = [];
        this.showLogOffPopupWidthInPercentage = "100%";
        this.isValidationError = false;
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.sessionSponsors = {
            Silver: [],
            Gold: [],
            Platinum: []
        };
        this.copyText = "Copy Link";
        this.url = winRef.nativeWindow.location.href;
        this.url = encodeURIComponent(this.url);
    }
    ViewCourseComponent.prototype.copyUrl = function (url) {
        var _this = this;
        var selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = decodeURIComponent(url);
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        /* Alert the copied text */
        this.copyText = "Copied!!";
        setTimeout(function () {
            _this.copyText = "Copy Link";
        }, 5000);
    };
    ViewCourseComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    ViewCourseComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            _this.query = params['sessionId'] || 0;
            console.log('The CourseId in ViewCourse ==>' + _this.query);
            if (_this.query != '0') {
                _this.userService.getCourse(_this.query).subscribe(function (data) {
                    console.log(data);
                    _this.courseDetail = data;
                    if (data.sessionSponsors.length > 0) {
                        data.sessionSponsors.forEach(function (element) {
                            if (element.sponsorshipLevel == 'Silver') {
                                _this.sessionSponsors.Silver.push(element);
                            }
                            if (element.sponsorshipLevel == 'Gold') {
                                _this.sessionSponsors.Gold.push(element);
                            }
                            if (element.sponsorshipLevel == 'Platinum') {
                                _this.sessionSponsors.Platinum.push(element);
                            }
                        });
                    }
                    if (data.url) {
                        _this.video_html = _this.embedService.embed(data.url);
                    }
                    _this.creator = data.creator;
                    _this.startTime = data.startTime;
                    _this.endTime = data.endTime;
                    if (_this.courseDetail.currentSchedule != undefined) {
                        _this.schedual = _this.courseDetail.currentSchedule;
                        if (_this.schedual.selectedDaysOfWeekStr != null) {
                            //this.schedual.selectedDaysOfWeekStr.sort(this.daysOfWeekSorter);
                            var that_1 = _this;
                            var sortDays = function (a, b) {
                                a = that_1.daysOfWeek.indexOf(a);
                                b = that_1.daysOfWeek.indexOf(b);
                                return a < b ? 0 : 1;
                            };
                            var myArrayOfDays = _this.schedual.selectedDaysOfWeekStr.sort(sortDays);
                        }
                    }
                    if (!_this.courseDetail.imageURL) {
                        _this.courseDetail.imageURL = "assets/images/worldmap.png";
                    }
                    if (localStorage.getItem('timezone')) {
                        _this.timezone = localStorage.getItem('timezone');
                    }
                    if (_this.timezone) {
                        _this.timeZonechange(_this.timezone);
                    }
                }, function (error) { });
            }
        });
    };
    ViewCourseComponent.prototype.registerClick = function (id) {
        localStorage.setItem('regcourse', id);
        // alert("Please Login For Register Course.");
        // this.showOnlyOverlay = true;
        // this.showLogOffModalDialog = true;
        // this.showLogOffMessageTitle = "Info!!";
        // this.showLogOffMessages.push("Please Login or Signup to Register for Session");
        // this.showLogOffPopupWidthInPercentage = "100%";
        // this.isValidationError = false;
        $(".btn.loginBtnn.headerLoginButton").trigger("click");
    };
    ViewCourseComponent.prototype.sponsorClick = function (id) {
        localStorage.removeItem('regcourse');
        localStorage.setItem('sponcourse', id);
        // alert("Please Login For Register Course.");
        // this.showOnlyOverlay = true;
        // this.showLogOffModalDialog = true;
        // this.showLogOffMessageTitle = "Info!!";
        // this.showLogOffMessages.push("Please Login or Signup to Register for Session");
        // this.showLogOffPopupWidthInPercentage = "100%";
        // this.isValidationError = false;
        $(".btn.loginBtnn.headerLoginButton").trigger("click");
    };
    ViewCourseComponent.prototype.navigateURL = function (url) {
        if (url.substring(0, 4) != 'http') {
            url = "//" + url;
        }
        window.open(url, "_blank");
    };
    ViewCourseComponent.prototype.closeErrorMessagePopup = function () {
        this.showLogOffMessages = [];
        this.showLogOffModalDialog = false;
        this.showOnlyOverlay = false;
    };
    ViewCourseComponent.prototype.timeZonechange = function (data) {
        this.courseDetail.displayStartDateOnlyConverted = this.timeZoneConverstionService.convertTimezone(data, 'date', this.courseDetail.courseStartDTime);
        this.courseDetail.timeZoneConverted = data;
        this.courseDetail.displayStopDateOnlyConverted = this.timeZoneConverstionService.convertTimezone(data, 'date', this.courseDetail.courseEndDTime);
        this.courseDetail.startTimeConverted = this.timeZoneConverstionService.convertTimezone(data, 'time', this.courseDetail.courseStartDTime);
        this.courseDetail.endTimeConverted = this.timeZoneConverstionService.convertTimezone(data, 'time', this.courseDetail.courseEndDTime);
        localStorage.setItem('timezone', data);
    };
    return ViewCourseComponent;
}());
export { ViewCourseComponent };
//# sourceMappingURL=viewcourse.component.js.map